import { Controller } from "@hotwired/stimulus"

// A group of checkboxes with Select all / Deselect all (search-aware — they only
// touch rows the `list-filter` controller is currently showing) and an optional live
// count target. Used by the column picker's Conversions tab. Search itself is
// handled by the shared `list-filter` controller.
export default class extends Controller {
  static targets = ["checkbox", "count"]

  connect() {
    this.updateCount()
  }

  selectAll() {
    this.setVisible(true)
  }

  deselectAll() {
    this.setVisible(false)
  }

  setVisible(checked) {
    this.visibleCheckboxes().forEach((checkbox) => { checkbox.checked = checked })
    this.updateCount()
  }

  updateCount() {
    if (this.hasCountTarget) {
      this.countTarget.textContent = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    }
  }

  // Rows hidden by the search (list-filter sets display:none) are skipped.
  visibleCheckboxes() {
    return this.checkboxTargets.filter((checkbox) => {
      const row = checkbox.closest('[data-list-filter-target="item"]')
      return !row || row.style.display !== "none"
    })
  }
}
